<ion-header class="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb__item" [routerLink]="[breadcrumb.link]" detail="false">
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
    </ion-buttons>
    <ion-title>Reports</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="wrapper">
    <ul class="reports">
      <li class="reports__item" *ngFor="let report of reports, let i = index" [ngStyle]="{order: i + 1}" (click)="showGraph(i)">
        <span class="reports__item__circle" [ngStyle]="{ background: 'rgba(' + report.color + ')', width: (100 - (4 * i)) + '%' }"></span>
        <div
          class="reports__item__box"
          [ngStyle]="{ borderTopColor: 'rgba(' + report.color + ',0.8)', width: (100 - (4 * i)) + '%' }"
        ></div>
        <span class="reports__item__name" [innerHTML]="report.name"></span>
        <span class="reports__item__focus" [innerHTML]="'Dein Fokus'" *ngIf="i === 1"></span>
      </li>
      <li [className]="'reports__detail --position-' + graphPosition" [ngStyle]="{order: order + 1}" [ngClass]="{'--open': showOrder}">
        <ul class="reports__detail__list">
          <li class="reports__detail__list__item --positive">
            <div class="reports__detail__list__item__info">
              <span class="reports__detail__list__item__info__type" [innerHTML]="'Umsatz'"></span>
              <span class="reports__detail__list__item__info__value" [innerHTML]="'19.269 €'"></span>
              <ion-icon class="reports__detail__list__item__info__icon" name="arrow-up"></ion-icon>
            </div>
            <img src="/assets/reports/sample-graph-positive.png" alt="" class="reports__detail__list__item__graph" />
            <span class="reports__detail__list__item__emoticon">😀</span>
          </li>
          <li class="reports__detail__list__item --negative">
            <div class="reports__detail__list__item__info">
              <span class="reports__detail__list__item__info__type" [innerHTML]="'Umsatz'"></span>
              <span class="reports__detail__list__item__info__value" [innerHTML]="'19.269 €'"></span>
              <ion-icon class="reports__detail__list__item__info__icon" name="arrow-up"></ion-icon>
            </div>
            <img src="/assets/reports/sample-graph-negative.png" alt="" class="reports__detail__list__item__graph" />
            <span class="reports__detail__list__item__emoticon">😟</span>
          </li>
          <li class="reports__detail__list__item --positive">
            <div class="reports__detail__list__item__info">
              <span class="reports__detail__list__item__info__type" [innerHTML]="'Umsatz'"></span>
              <span class="reports__detail__list__item__info__value" [innerHTML]="'19.269 €'"></span>
              <ion-icon class="reports__detail__list__item__info__icon" name="arrow-up"></ion-icon>
            </div>
            <img src="/assets/reports/sample-graph-positive.png" alt="" class="reports__detail__list__item__graph" />
            <span class="reports__detail__list__item__emoticon">😀</span>
          </li>
        </ul>
        <span class="reports__detail__arrow"></span>
      </li>
    </ul>
  </div>
  <!-- <ion-button [routerLink]="[routes.history]"> History </ion-button> -->
</ion-content>
